import Vue from "vue";
import Router from "vue-router";

import { getLoggedClient, refreshAccessToken, removeClientStore } from '@/app/views/auth/shared/services';
import { CLIENT_API_CREDENTIALS, registerRoutes, MANTENIMIENTO } from '@/config';

// import { clientsRoutes } from '@/app/views/clientes';
import { clientRoutes } from '@/app/views/clientes';
import { clientSettingsRoutes } from '@/app/views/clientes';

import { authRoutes } from '@/app/views/auth';
// import { userRoutes } from '@/app/views/usuarios';
import { paymentRoutes } from '@/app/views/pagos';
import { homeRoutes } from '@/app/views/home';
// import { searchRoutes } from "../views/buscador";

import { parkingRoutes } from '@/app/views/parkings';

// Containers
const TheContainer = () => import("@/app/containers/TheContainer");

const Mantenimiento = () => import('@/app/views/Maintenance');

Vue.use(Router);

const vistaMantenimiento = MANTENIMIENTO;

const mantenimientRoutes = [
  {
    path: "*",
    redirect: '/proximamente',
    component: Mantenimiento,
  },

  {
    path: '/',
    redirect: '/proximamente',
    component: Mantenimiento,
  },

  {
    path: '/proximamente',
    name:'Maintenance',
    component: Mantenimiento,
    meta: {
      auth: false
    }
  }
]

const MainRoutes = [

  {
    path: "/",
    redirect: "/parkings", //"/buscador-tarifas", ///dashboard
    name: "mimoTo",
    component: TheContainer,
    children: [
      ...homeRoutes,
      ...clientRoutes,
      // ...searchRoutes,
      ...parkingRoutes,

      {
        //// Gestión
        path: "gestion",
        redirect: "/gestion/estacionamientos",
        name: "Gestión",
        component: {
          render(c) {
            return c("router-view");
          }
        },
        children: [
          ...clientRoutes,
          // ...clientsRoutes,
          ...paymentRoutes,
        ]
      },

      ...clientSettingsRoutes,

    ]
  },
  ...authRoutes,
  {
    path: '/tpv-pago-ok',
    name:'tpv-pago-ok',
    component: () => import(/* webpackChunkName: "tpv" */ '@/app/views/redsys/TpvOk.vue'),
    meta: {
      auth: false
    }
  },
  {
    path: '/tpv-pago-ko',
    name:'tpv-pago-ko',
    component: () => import(/* webpackChunkName: "tpv" */ '@/app/views/redsys/TpvKo.vue'),
    meta: {
      auth: false
    }
  },
  {
    path: '/tpv-order',
    name:'TpvOrder',
    component: () => import(/* webpackChunkName: "tpv" */ '@/app/views/redsys/TpvOrder.vue'),
    meta: {
      auth: false
    }
  },
  {
    path: '/tpv-response',
    name:'TpvResponse',
    component: () => import(/* webpackChunkName: "tpv" */ '@/app/views/redsys/TpvResponse.vue'),
    meta: {
      auth: false
    }
  },
  // {
  //   path: '/tpv-test',
  //   name:'TpvResponse',
  //   component: () => import(/* webpackChunkName: "tpv" */ '@/app/views/redsys/Redsys.vue'),
  //   meta: {
  //     auth: false
  //   }
  // },
  {
    path: "*",
    redirect: "/"
  }
]

let routes = [];

if (vistaMantenimiento) {
  routes = [...mantenimientRoutes];

} else {

  // routes = [...MainRoutes, ...[ {path: "*",redirect: "/"}] ] ;
  routes = [...MainRoutes ] ;
}

// const routes = [...clientsRoutes, ...MainRoutes]





const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes
});


router.afterEach((to) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      pagePath: to.fullPath,
      pageTitle: document.title,
    });
  }
});

router.beforeEach(async (to, from, next) => {

  if (vistaMantenimiento) {

    if ('Maintenance' !== to.name) {
      next({
        path: "/proximamente",
      });

    } else {
      next();
    }

  } else {

    let token = localStorage.getItem("token");
    let user,
      expired = false;

    if (
      token &&
      localStorage.getItem("user_email") !== CLIENT_API_CREDENTIALS.email &&
      localStorage.getItem("user_name") !== CLIENT_API_CREDENTIALS.name
    ) {
      let response = await getLoggedClient().catch(e => e); //checkValid();

      if (response.status === "success") {

        /// Usuario baneado
        if (response.data.banned) {

          token = null;
          expired = true;

          localStorage.removeItem('token');

        } else {

          const storageLoginTime = localStorage.getItem("login_time");
          // let storageExpiresIn = localStorage.getItem('expires_in');
          // 3600 segundos = 60 minutos = 1 hora

          // Cambio expiración token
          // 28800 segundos = 480 minutos = 8h

          let now = new Date();

          let dateExpiraSoon = new Date(storageLoginTime);

          let dateExpira = new Date(storageLoginTime);

          dateExpira.setHours(dateExpira.getHours() + 1);
          dateExpiraSoon.setMinutes(dateExpiraSoon.getMinutes() + 40);
          // dateExpiraSoon.setMinutes(dateExpira.getMinutes() - 15);

          if (now >= dateExpiraSoon && now <= dateExpira) {
            // token próximo a caducar
            await refreshAccessToken();
          }

          user = response.data;
          expired = false;
        }


      } else {

        localStorage.removeItem("token");
        token = null;
        expired = true;
      }

    } else if ( registerRoutes.includes(to.name) ) {
      expired = true;

    } else {
      localStorage.removeItem("token");
      token = null;
      expired = true;
    }

    // to.matched.some(record => record.meta.auth
    if (to.meta && to.meta.auth == true) {
      removeClientStore();

      if (expired) {
        next({
          path: "/login",
          query: {
            expired: expired
          }
        });
      }

      else if (token && !expired) {
        to.query.user = user;
        next();
      }

      else {
        next({
          path: "/login",
          query: {
            expired: expired
          }
        });
      }

    } else if (to.meta && to.meta.auth == false) {

      if (token) {

        if ( registerRoutes.includes(to.name) ) {
          // INFO: token client APP. user undefined
          // to.query.user = user;
          next();

        } else {
          removeClientStore();
          // TODO: remove APP client credentials
          next({
            path: "/",
            query: { user: user }
          });
        }

      } else {
        next();
      }
    } else {
      next();
    }

  }





});

export default router;
